import { store } from "../store/index";
import {
  userLogout,
  getProfile,
  checkSsoToken,
  setAuthUser,
  setAuthToken,
} from "../store/actions/AuthActions";

export const checkSso = async () => {
  const result = await store.dispatch(checkSsoToken());
  if (result?.payload?.access_token) {
    await store.dispatch(setAuthUser(result.payload.user));
    await store.dispatch(
      setAuthToken({
        access_token: result.payload.access_token,
        token_expiration: result.payload.token_expiration,
      })
    );
    return "OK";
  }

  return null;
};

export const profile = async () => {
  const result = await store.dispatch(getProfile());
  if (result?.payload?.data) {
    return result.payload.data;
  }

  return null;
};

export const logout = async () => {
  await store.dispatch(userLogout());

  return null;
};
